
import React from 'react';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface CountrySearchSectionProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  countryName: string;
  startIndex: number;
  endIndex: number;
  totalCities: number;
  currentPage: number;
  totalPages: number;
}

const CountrySearchSection = ({
  searchTerm,
  setSearchTerm,
  countryName,
  startIndex,
  endIndex,
  totalCities,
  currentPage,
  totalPages
}: CountrySearchSectionProps) => {
  return (
    <>
      <div className="mb-8">
        <div className="relative max-w-md mx-auto">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-brand-gray-400" />
          <Input
            placeholder={`Search cities in ${countryName}...`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10"
          />
        </div>
      </div>

      <div className="mb-6 text-center">
        <h2 className="text-2xl font-semibold text-brand-gray-900 mb-2">
          Mental Health Professionals by City
        </h2>
        <p className="text-brand-gray-600">
          Showing {startIndex + 1}-{endIndex} of {totalCities} cities
          {totalPages > 1 && ` (Page ${currentPage} of ${totalPages})`}
        </p>
      </div>
    </>
  );
};

export default CountrySearchSection;
